import type { Lang } from "./config";

export interface UIStrings {
  meta: { docTitle: string };
  nav: { expertise: string; work: string; education: string; contact: string };
  leadership: { eyebrow: string; title: string; sub: string };
  hero: {
    viewWork: string;
    github: string;
    contact: string;
    stats: { years: string; commercial: string; featured: string };
  };
  portfolio: {
    eyebrow: string;
    title: string;
    sub: string;
    filters: { all: string; openSource: string; commercial: string };
    badges: { openSource: string; commercial: string };
    viewDetails: string;
  };
  education: {
    eyebrow: string;
    title: string;
    sub: string;
    viewCertificates: string;
    visit: string;
  };
  contacts: { eyebrow: string; title: string; sub: string };
  footer: { built: string };
  a11y: {
    primaryNav: string;
    openDetails: string; // "{title}" placeholder
    closeDialog: string;
    backToTop: string;
    toggleMenu: string;
    switchToLight: string;
    switchToDark: string;
    switchLanguage: string;
    screenshot: string; // "{title}" and "{n}" placeholders
  };
}

export const ui: Record<Lang, UIStrings> = {
  en: {
    meta: { docTitle: "Artyom Tarasov — Lead Mobile Developer" },
    nav: {
      expertise: "Expertise",
      work: "Work",
      education: "Education",
      contact: "Contact",
    },
    leadership: {
      eyebrow: "Engineering leadership",
      title: "What I bring as a lead",
      sub: "Owning technical direction, the quality bar and delivery on the products I build.",
    },
    hero: {
      viewWork: "View my work",
      github: "GitHub",
      contact: "Get in touch",
      stats: {
        years: "Years in Android",
        commercial: "Commercial projects",
        featured: "Featured here",
      },
    },
    portfolio: {
      eyebrow: "Portfolio",
      title: "Sample projects",
      sub: "Android, cross-platform and backend work — from experiments to software shipped to production.",
      filters: { all: "All", openSource: "Open source", commercial: "Commercial" },
      badges: { openSource: "Open source", commercial: "Commercial" },
      viewDetails: "View details",
    },
    education: {
      eyebrow: "Background",
      title: "Education & training",
      sub: "Where I studied, competed and kept sharpening the fundamentals.",
      viewCertificates: "View certificates",
      visit: "Visit",
    },
    contacts: {
      eyebrow: "Contacts",
      title: "Let's get in touch",
      sub: "Open to interesting mobile and cross-platform work — reach out on any of these.",
    },
    footer: { built: "Built with React & Vite" },
    a11y: {
      primaryNav: "Primary",
      openDetails: "Open details for {title}",
      closeDialog: "Close dialog",
      backToTop: "Back to top",
      toggleMenu: "Toggle menu",
      switchToLight: "Switch to light theme",
      switchToDark: "Switch to dark theme",
      switchLanguage: "Switch language",
      screenshot: "{title} — screenshot {n}",
    },
  },
  ru: {
    meta: { docTitle: "Артём Тарасов — Ведущий мобильный разработчик" },
    nav: {
      expertise: "Экспертиза",
      work: "Проекты",
      education: "Образование",
      contact: "Контакты",
    },
    leadership: {
      eyebrow: "Инженерное лидерство",
      title: "Чем я силён как лид",
      sub: "Держу техническое направление и планку качества, довожу продукты до релиза.",
    },
    hero: {
      viewWork: "Смотреть работы",
      github: "GitHub",
      contact: "Связаться",
      stats: {
        years: "лет в Android",
        commercial: "коммерческих проектов",
        featured: "в подборке",
      },
    },
    portfolio: {
      eyebrow: "Портфолио",
      title: "Примеры проектов",
      sub: "Android, кросс-платформа и бэкенд — от экспериментов до софта в продакшене.",
      filters: { all: "Все", openSource: "Open source", commercial: "Коммерческие" },
      badges: { openSource: "Open source", commercial: "Коммерческий" },
      viewDetails: "Подробнее",
    },
    education: {
      eyebrow: "Опыт",
      title: "Образование и обучение",
      sub: "Где учился, соревновался и укреплял базу.",
      viewCertificates: "Сертификаты",
      visit: "Открыть",
    },
    contacts: {
      eyebrow: "Контакты",
      title: "Давайте пообщаемся",
      sub: "Открыт к интересным задачам в мобильной и кросс-платформенной разработке — пишите удобным способом.",
    },
    footer: { built: "Сделано на React и Vite" },
    a11y: {
      primaryNav: "Основная навигация",
      openDetails: "Открыть подробности: {title}",
      closeDialog: "Закрыть",
      backToTop: "Наверх",
      toggleMenu: "Меню",
      switchToLight: "Включить светлую тему",
      switchToDark: "Включить тёмную тему",
      switchLanguage: "Сменить язык",
      screenshot: "{title} — скриншот {n}",
    },
  },
};
